export default {
  SET_TAGS: (state, { type, list }) => {
    state.tags[type] = list;
  },
};
